<!-- src/components/IframeWrapper.svelte -->
<script>
  import { onMount, onDestroy } from 'svelte';

  export let src = '';
  export let title = '';

  export let showToolbar = true;
  export let showSpotlightButton = true;
  export let showExitButton = true;

  let iframeRef;
  let focusAnchor;

  function refocusApp() {
    focusAnchor?.focus();

    window.dispatchEvent(new CustomEvent('open-spotlight'));
  }

  function exitModule() {
    focusAnchor?.focus();

    window.dispatchEvent(new CustomEvent('exit-module'));
  }

  function handleMessage(event) {
    if (!event.data) return;

    switch (event.data.type) {
      case 'OPEN_SPOTLIGHT':
        window.dispatchEvent(new CustomEvent('open-spotlight'));
        break;

      case 'EXIT_MODULE':
        window.dispatchEvent(new CustomEvent('exit-module'));
        break;
    }
  }

  onMount(() => {
    window.addEventListener('message', handleMessage);
  });

  onDestroy(() => {
    window.removeEventListener('message', handleMessage);
  });
</script>

<div class="iframe-wrapper">
  <div bind:this={focusAnchor} tabindex="-1" class="sr-only"></div>

  {#if showToolbar}
    <div class="iframe-toolbar">
      {#if showSpotlightButton}
        <button class="toolbar-btn" on:click={refocusApp}>⌘K / ESC để mở Spotlight</button>
      {/if}

      {#if showExitButton}
        <button class="toolbar-btn secondary" on:click={exitModule}>Thoát</button>
      {/if}
    </div>
  {/if}

  <iframe
    bind:this={iframeRef}
    {src}
    {title}
    class="iframe-page"
    loading="eager"
    allow="camera; microphone; fullscreen"
    referrerpolicy="no-referrer">
  </iframe>
</div>

<style>
  .iframe-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .iframe-toolbar {
    position: absolute;
    top: 10px;
    right: 10px;

    display: flex;
    gap: 8px;

    z-index: 9999;
  }

  .toolbar-btn {
    border: 1px solid #d1d5db;
    background: rgba(255, 255, 255, 0.95);

    border-radius: 10px;

    padding: 8px 12px;

    font-size: 12px;
    font-weight: 500;

    cursor: pointer;

    backdrop-filter: blur(8px);

    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  .toolbar-btn:hover {
    background: white;
  }

  .toolbar-btn.secondary {
    color: #ef4444;
  }

  .iframe-page {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
  }
</style>
